// This file patches the problematic @react-three/drei modules
// It should be imported before any drei components are used

import { NoColorSpace, SRGBColorSpace } from 'three';

// Patch Three.js to include missing constants
if (typeof window !== 'undefined') {
  // Add compatibility constants to the global window object
  (window as any).LinearEncoding = NoColorSpace;
  (window as any).sRGBEncoding = SRGBColorSpace;
  
  console.log('Three.js compatibility patches applied');
}

// Export compatibility constants
export const LinearEncoding = NoColorSpace;
export const sRGBEncoding = SRGBColorSpace; 